export default "__VITE_ASSET__55c74db7__"